export const codeArr = [
    {
      code: `for (initialization; condition; increment/decrement) {
      // Code to be executed repeatedly
    }`
    },
    {
      code: `for (int i = 1; i <= 5; i++) {
      printf("%d\\n", i);
    }`
    },
    {
      code: `while (condition) {
      // Code to be executed repeatedly
    }`
    },
    {
      code: `int i = 1;
    while (i <= 5) {
      printf("%d\\n", i);
      i++;
    }`
    },
    {
      code: `do {
      // Code to be executed repeatedly
    } while (condition);`
    },
    {
      code: `int i = 1;
    do {
      printf("%d\\n", i);
      i++;
    } while (i <= 5);`
    }
  ];
  